import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

/**
 * Brands Slider
 */
(() => {
  document.querySelectorAll('.js-brands-carousel').forEach((item) => {
    item.parentNode.classList.add('custom-brands', 'container');
    item.classList.add('splide');

    const slideParent = item.querySelector(':scope > div');
    slideParent.classList.add('splide__track');

    const slideInner = document.createElement('div');
    slideInner.className = 'splide__list';
    slideParent.appendChild(slideInner);

    slideParent.querySelectorAll('.tileparent').forEach((slide) => {
      slide.classList.add('splide__slide');
      slideInner.appendChild(slide);
    });

    const brandSlider = new Splide(item, {
      type: 'loop',
      perPage: 6,
      perMove: 1,
      gap: 20,
      pagination: false,
      arrows: false,
      autoScroll: {
        speed: 0.5,
      },
      breakpoints: {
        1024: {
          perPage: 5,
        },
        768: {
          perPage: 4,
        },
        640: {
          perPage: 3,
        },
        480: {
          perPage: 2,
        },
      },
    });

    brandSlider.mount({ AutoScroll });
  });

  // settimeout to fix alignment issues
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
